(function(){
    'use strict';

    angular
    .module('app')
    .controller('TabsController', TabsController)
 
    TabsController.$inject = ["$http","$timeout","$uibModal", "$log", "$document","$sce"];
        
    function TabsController($http,$timeout,$uibModal, $log, $document,$sce)
    {                       
        var vm = this;
        vm.datos = {};
        vm.datos.filas = [];
        
        vm.fieldName = ""

        vm.htmlDecode = function(input){
          var e = document.createElement('div');
          e.innerHTML = input;
          return e.childNodes[0].nodeValue;
        }

        vm.sortableOptions = {
            handle: '.movimientoac',
            placeholder:'app2',
            stop: function(e, ui) { 
            	//console.log("update");
            	vm.update();
            },
          }; 

        vm.initVars = function(fieldName,value){
            if(value!=""){
               value = vm.htmlDecode(value);
        	   value = JSON.stringify(value);
               value = value.replace(/\\n/g, "");
               value = value.replace(/\\r/g, "");
               value = value.replace(/\\t/g, "");
               value = value.replace(/([^>"]*)"(?=[^<]*>)/g, '$1\\\\"');
               console.log(value);
        	   value = JSON.parse(value);
        	   vm.datos = JSON.parse(value);
               console.log(vm.datos);
               for(var cont=0;cont<vm.datos.filas.length;cont++){
                if(typeof vm.datos.filas[cont].filas=='undefined'){
                    var copiedObject = new Object();
                    copiedObject.fila = $.extend(true, {}, vm.datos.filas[cont].fila);
                    copiedObject.columnas = $.extend(true, {}, vm.datos.filas[cont].columnas);
                    vm.datos.filas[cont].filas = [];
                    vm.datos.filas[cont].filas.push(copiedObject);
                }
               }
               console.log(vm.datos);
               //console.log(vm.datos);
            }
        	vm.fieldName = fieldName;
        }

        vm.addFila = function(){
            var datos = new Object();
            datos["fila"] = new Object();
            datos["fila"].layout = "1/1";
            datos["columnas"] = new Array();
            datos["columnas"][0] = new Object();
            datos["columnas"][0].medida = 12;
            datos["columnas"][0].medida_tablet = "";
            datos["columnas"][0].medida_mobile = "";
            datos["columnas"][0].layout = "1/1";
            datos["columnas"][0].layout_tablet = "";
            datos["columnas"][0].layout_mobile = "";
            datos["columnas"][0].bloques = [];

            var object = new Object();
            vm.datos.filas.push(object);     
            if(typeof vm.datos.filas[vm.datos.filas.length-1].filas == 'undefined'){
                vm.datos.filas[vm.datos.filas.length-1].filas = [];
            }
            vm.datos.filas[vm.datos.filas.length-1].filas.push(datos);     
            vm.update();      
            vm.edit(vm.datos.filas[vm.datos.filas.length-1]);
        }

        vm.borrarBloque = function(dato){
            var search = false;
            for(var cont=0;cont<vm.datos.filas.length && !search;cont++){
                if(vm.datos.filas[cont] == dato){
                    vm.datos.filas.splice(cont, 1);
                    search = true;
                }
            }
            vm.update();
        } 

        vm.update = function(){
			var json = angular.toJson(vm.datos);
			$timeout(function(){
				$('#'+vm.fieldName+"-jsonac").val(json).trigger("change");
			});
		}


        vm.modalEditContent = "";
        vm.editContent = function(bloque){
            vm.modalEditContent = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'contenidoTexto.html',
              size: 'lg',
              controller: function($scope) {
                $scope.texto = bloque.texto;
                $scope.foto = bloque.foto;
                $scope.koForm = function(){
                    vm.modalEditContent.close();
                }
                $scope.okForm = function(){
                    bloque.texto = $scope.texto;
                    bloque.foto = $scope.foto;
                    vm.update();
                    vm.modalEditContent.close();
                }
              }
            });
        }

        vm.cambiarColumnas = function(dato,value){
            var columnasActuales = dato.columnas.length;
            console.log(dato);
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length;cont++){
                if(typeof dato.columnas[cont] == 'undefined'){
                    var datoAInsertar = new Object();
                    datoAInsertar.bloques = new Array();
                    dato.columnas.push(datoAInsertar);
                }
                var totalColumnas = 12;

                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
                dato.columnas[cont].medida = division;
                dato.columnas[cont].layout = partesSeparadas[cont];
            }
            dato.layout = value;
            //console.log(value);
            var contSeg = cont;
            console.log(columnasActuales);
            for(cont;cont<columnasActuales;cont++){
                for(var contBloq=0;contBloq<dato.columnas[contSeg].bloques.length;contBloq++){
                        dato.columnas[0].bloques.push(dato.columnas[contSeg].bloques[contBloq]);
                }
                dato.columnas.splice(contSeg, 1);
            }
            vm.update();
        }

        vm.cambiarColumnasTablet = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length && cont<dato.columnas.length;cont++){
                var totalColumnas = 12;
                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
                
                dato.columnas[cont].medida_tablet = division;
                dato.columnas[cont].layout_tablet = partesSeparadas[cont];
               
            }
            if(partesSeparadas.length<dato.columnas.length){
                for(cont;cont<dato.columnas.length;cont++){
                    dato.columnas[cont].medida_tablet = "";
                    dato.columnas[cont].layout_tablet = "";
                }
            }
            dato.layout_tablet = value;
            vm.update();  
        } 
        vm.cambiarColumnasMobile = function(dato,value){
            var columnasActuales = dato.columnas.length;
            var partesSeparadas = value.split("+");
            for(var cont=0;cont<partesSeparadas.length && cont<dato.columnas.length;cont++){
                var totalColumnas = 12;
                var layoutEx = partesSeparadas[cont].split("/");
                var division = (totalColumnas * layoutEx[0]) / layoutEx[1];
               
                dato.columnas[cont].medida_mobile = division;
                dato.columnas[cont].layout_mobile = partesSeparadas[cont];
            }
            if(partesSeparadas.length<dato.columnas.length){
                for(cont;cont<dato.columnas.length;cont++){
                    dato.columnas[cont].medida_mobile = "";
                    dato.columnas[cont].layout_mobile = "";
                }
            }
            dato.layout_mobile = value;
            vm.update();  
        } 

        vm.selectedColumna = function(dato, selected){
            if(dato.layout==selected){
                return "selected";
            }  
            return false;
        } 
        vm.selectedColumnaTablet = function(dato, selected){
            if(dato.layout_tablet==selected){
                return "selected";
            }  
            return false;
        } 
        vm.selectedColumnaMobile = function(dato, selected){
            if(dato.layout_mobile==selected){
                return "selected";
            }  
            return false;
        } 

        vm.modalAjFila = "";
        vm.ajustesFila = function(dato){
            console.log("ajustes");
            vm.modalAjFila = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'ajustesfilaAc.html',
              size: 'lg',
              controller: function($scope) {
                $scope.dato = dato;
                //console.log(dato);
                $scope.koForm = function(){
                    vm.modalAjFila.close();
                }
                $scope.okForm = function(){
                    vm.modalAjFila.close();
                }
                $scope.selectedColumna = function(dato, selected){
                    return vm.selectedColumna(dato,selected);
                }
                $scope.selectedColumnaTablet = function(dato, selected){
                    return vm.selectedColumnaTablet(dato,selected);
                }
                $scope.selectedColumnaMobile = function(dato, selected){
                    return vm.selectedColumnaMobile(dato,selected);
                }
                $scope.cambiarColumnas = function(dato,value){
                    vm.cambiarColumnas(dato,value);
                }
                $scope.cambiarColumnasTablet = function(dato,value){
                    vm.cambiarColumnasTablet(dato,value);
                }
                $scope.cambiarColumnasMobile = function(dato,value){
                    vm.cambiarColumnasMobile(dato,value);
                }
              }
            });
        }

        vm.columnaModalEditar = "";
        vm.columnaModal = function(columna){
            vm.columnaModalEditar = $uibModal.open({
                  animation: true,
                  ariaLabelledBy: 'modal-title-top',
                  ariaDescribedBy: 'modal-body-top',
                  templateUrl: 'colunaModal.html',
                  size: 'lg',
                  controller: function($scope) {
                    $scope.extraclass = "";
                    $scope.hiddendesk = "";
                    $scope.hiddentab = "";
                    $scope.hiddenmob = "";
                    console.log(columna.config);
                    if(columna.config != null){
                        if(typeof columna.config.extraclass != 'undefined'){
                            $scope.extraclass = columna.config.extraclass;
                        }
                        if(typeof columna.config.hiddendesk != 'undefined'){
                            $scope.hiddendesk = eval(columna.config.hiddendesk);
                        }
                        if(typeof columna.config.hiddentab != 'undefined'){
                            $scope.hiddentab = eval(columna.config.hiddentab);
                        }
                        if(typeof columna.config.hiddenmob != 'undefined'){
                            $scope.hiddenmob = eval(columna.config.hiddenmob);
                        }
                    }
                    $scope.okForm = function(){
                        if(columna.config == null){
                            columna.config = {};
                        }
                        columna.config.extraclass = $scope.extraclass;
                        columna.config.hiddendesk = $scope.hiddendesk;
                        columna.config.hiddentab = $scope.hiddentab;
                        columna.config.hiddenmob = $scope.hiddenmob;
                        vm.columnaModalEditar.close();
                    }
                    $scope.koForm = function(){
                        vm.columnaModalEditar.close();
                    }
                  }
              });
        }

        vm.modalContenido = "";
        vm.edit = function (dato) {
             vm.modalContenido = $uibModal.open({
              animation: true,
              ariaLabelledBy: 'modal-title-top',
              ariaDescribedBy: 'modal-body-top',
              templateUrl: 'contenido.html',
              size: 'lg',
              controller: function($scope) { 
                console.log(dato);
                $scope.titulo = dato.titulo;
                $scope.icono = dato.icono;
                $scope.dato = {};
                $scope.dato.bloques = [];
                $scope.sortableOptions = {
                    handle: '.movimientoac',
                    placeholder:'app2'
                  }; 
                if(typeof dato.texto != 'undefined'){
                    $scope.dato.bloques[0] = {};
                    $scope.dato.bloques[0].texto = dato.texto;
                }
                $scope.dato.layout = "";
                if(typeof dato.columnas == 'undefined'){
                    dato.columnas = [];
                    var contenido = new Object();
                    contenido.bloques = [];
                    contenido.bloques[0] = {};
                    contenido.bloques[0].texto = dato.texto;
                    dato.columnas.push(contenido);
                    $scope.dato.columnas = dato.columnas;
                }else{
                    $scope.dato.columnas = dato.columnas;
                    
                }

                $scope.columnaModal = function(columna){
                    vm.columnaModal(columna);
                }

                if(typeof $scope.dato.filas=='undefined'){
                    $scope.dato.filas = dato.filas;
                }
                $scope.koForm = function(){
                    vm.modalContenido.close();
                }
                $scope.okForm = function(){
                    //dato.texto = $scope.dato.texto;
                    dato.titulo = $scope.titulo;
                    dato.icono = $scope.icono;
                    vm.update();
                    vm.modalContenido.close();
                }
                $scope.showColumns = function(dato){
                    if(dato.hoverColumns){
                        dato.hoverColumns = false;
                    }else{
                        dato.hoverColumns = true;
                    }
                }

                $scope.ajustesFila = function(dato){
                    vm.ajustesFila(dato);
                }

                $scope.editContent = function(bloque){
                    vm.editContent(bloque);
                }

                $scope.modalInput = function(columna){
                    var columnaBloque = {};
                    columnaBloque.texto = "";
                    columnaBloque.foto = "";
                    columna.bloques.push(columnaBloque);
                    vm.editContent(columna.bloques[columna.bloques.length-1]);
                }

                $scope.borrarBloque = function(columna,data){
                    var search = false;
                    for(var cont=0;cont<columna.bloques.length && !search;cont++){
                        if(columna.bloques[cont] == data){
                            columna.bloques.splice(cont, 1);
                            search = true;
                        }
                    }
                    vm.update();
                } 

                $scope.addFila = function(){
                    //console.log("entro");
                    var datos = new Object();
                    datos["fila"] = new Object();
                    datos["fila"].layout = "1/1";
                    datos["columnas"] = new Array();
                    datos["columnas"][0] = new Object();
                    datos["columnas"][0].medida = 12;
                    datos["columnas"][0].medida_tablet = "";
                    datos["columnas"][0].medida_mobile = "";
                    datos["columnas"][0].layout = "1/1";
                    datos["columnas"][0].layout_tablet = "";
                    datos["columnas"][0].layout_mobile = "";
                    datos["columnas"][0].config = {};
                    datos["columnas"][0].config.hiddendesk = false;
                    datos["columnas"][0].config.hiddentab = false;
                    datos["columnas"][0].config.hiddenmob = false;
                    datos["columnas"][0].bloques = [];
                    dato.filas.push(datos);
                    vm.update();
                }

                $scope.borrarFila = function(dato,index){
                    dato.filas.splice(index,1);
                    vm.update();
                }

                $scope.cambiarColumnas = function(dato,value){
                    vm.cambiarColumnas(dato,value);
                } 
              }
            });
        }

    } 

})();